export default __webpack_public_path__ + "static/B0002-d966c7b261088239ea05e5c3ca8aa97f.png";